import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { RpcRoute } from '@core-layout/app/models/rpc-route';
import { RouteService } from '@core-layout/app/services/route.service';
import { SettingsStoreService } from '@settings/store/services/settings-store.service';

export const searchGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const routeService = inject(RouteService);

    return inject(SettingsStoreService).getSettings().pipe(
        take(1),
        switchMap(settings => {
            if (settings?.permissionSettings?.canSearchForListings != null && settings?.permissionSettings?.canSearchForListings) {
                return of(true);
            }

            routeService.navigate(RpcRoute.Login).catch(() => { });

            return of(false);
        })
    );
};
